<template>
    <CardShell>

        <CardHeader 
            heading="Upcoming Rentals" 
            route="/upcoming-rentals" 
            :loading="loading" 
            :seeAll="upcomingRentals !== null"
        />

        <div v-if="!loading">
            <EmptyCard
                class="w-75 pv5"
                v-if="!loading"
                :image="require(`@/assets/img/graphic_calendar.svg`)"
                description="There are no upcoming rentals."
                buttonText="Search for tools & equipment"
                route="search?q="
            />
            <RentalList :imageLarge="['sm']" v-else :tools="upcomingRentals" />
        </div>            

    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import CardHeader from '@/components/controls/CardHeader.vue';
import EmptyCard from '@/components/global/EmptyCard.vue';
import RentalList from '@/components/global/RentalList.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        CardShell,
        CardHeader,
        EmptyCard,
        RentalList
    },
    computed: {
        ...mapState('dashboard', ['upcomingRentals']),
        loading() {
            return this.upcomingRentals === null;
        }
    },
    methods: {
        ...mapActions('dashboard', ['getUpcomingRentals'])
    },
    created: function() {
        this.getUpcomingRentals();
    }
};
</script>
